import React, { useContext } from "react";
import { Text, BlockStack, InlineStack } from "@shopify/polaris";
import { FulfillmentContext } from "app/setup/modules/operator/features/_fulfillment/context";
// eslint-disable-next-line max-len
import ConsignmentPickup from "app/setup/modules/operator/features/_fulfillment/generic/consignmentShip/consignmentShip";

const HybridConsignmentPickup = () => {
  const { cms } = useContext(FulfillmentContext);
  return (
    <div className="hybridPickup">
      <BlockStack gap="10">
        <InlineStack>
          <Text variant="headingMd" as="h2">
            {cms("hybrid.consignmentPick.title")}
          </Text>
          {/* 
            <Link onClick={() => learnMore(cms("hybrid.consignmentPick.title"), cms("hybrid.consignmentPick.title"))}>
              {cms("common.learnMore")}
            </Link>
           */}
          <br />
          <Text as="span" tone="subdued">
            {cms("hybrid.consignmentPick.description")}
          </Text>
        </InlineStack>
      </BlockStack>
      <br />
      <ConsignmentPickup method="hybridConsignmentPickup" />
    </div>
  );
};

export default HybridConsignmentPickup;
